import gql from 'graphql-tag';
import { graphql } from '@apollo/react-hoc';
import { SimpleLoadingComponent } from '../../utils/apollo';
import NavianceSyncMessages from './NavianceSyncMessage';

const query = gql`
  query NavianceSyncMessage {
    viewer {
      id
      isNavianceLogin
      repVisitsAccount {
        id
        navianceSetupComplete
        navianceSettings {
          optIn
        }
      }
    }
  }
`;

export default SimpleLoadingComponent(graphql(query))(NavianceSyncMessages);
